module.exports = __webpack_public_path__ + "static/media/reports.bfc1a44f.svg";